import React from 'react';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControl from 'Components/UI/Meta/MetaControl';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import OutcomeCard from './OutcomeCard';
import metaOverrideSet from './metaOverrideSet';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
  },
  emptyState: {
    padding: theme.spacing(2),
  },
  groupHeader: {
    padding: theme.spacing(0, 0, 1),
  },
  groupContent: {
    borderLeftColor: theme.palette.facet.mediumGray,
    borderLeftStyle: 'dashed',
    borderLeftWidth: '1px',
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(2)}px`,
    margin: theme.spacing(0, 0, 1, 2),
    padding: theme.spacing(1, 0, 2, 2),
  },
});

const OutcomesTabContent = ({
  classes,
  resource: outcomeSummaryDetailsResource,
}) => {
  const resources = outcomeSummaryDetailsResource
    .attr('outcomeSummaryDetails')
    .resources()
    .list();

  return (
    <VerticalStack>
      <StackItem
        contentWidth={'lg'}
        hidden={resources.length > 0}
        fillsSpace
      >
        <Box className={classes.emptyState}>
          <Text color="mediumGray" text="No Outcomes" variant="h3" />
        </Box>
      </StackItem>
      <StackItem
        contentWidth={'lg'}
        fillsSpace
      >
        <Box className={classes.root}>
          {resources.map(outcomeSummaryDetailByYearResource => {
            return (
              <Box key={outcomeSummaryDetailByYearResource.id()}>
                <Box className={classes.groupHeader}>
                  <MetaControl
                    attrName="year"
                    resource={outcomeSummaryDetailByYearResource}
                    metaOverrideSet={metaOverrideSet}
                  />
                </Box>
                <Box className={classes.groupContent}>
                  {outcomeSummaryDetailByYearResource
                    .attr('outcomeSummaryDetails')
                    .resources()
                    .list()
                    .map(outcomeSummaryDetailResource => {
                      return (
                        <OutcomeCard
                          key={outcomeSummaryDetailResource.id()}
                          outcomeSummaryDetailResource={
                          outcomeSummaryDetailResource
                        }
                        />
                      );
                    })}
                </Box>
              </Box>
            );
          })}
        </Box>
      </StackItem>
    </VerticalStack>
  );
};

OutcomesTabContent.defaultProps = {};

OutcomesTabContent.propTypes = {
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(OutcomesTabContent);
